import styled from 'styled-components';
import SectionContainer from '../../components/SectionContainer';

export const ParamsLine = styled.div`
  padding-top: 15px;
  color: ${({ theme }) => theme.black};

  box-shadow: 0 0 16px rgba(0, 0, 0, 0.08);
`;

export const ParamsContainer = styled(SectionContainer)`
  align-items: flex-start;
  justify-content: center;
  padding: 0 12px 0;
  @media(min-width: 1024px) {
    justify-content: flex-start;
    padding: 0 25px 0;
    max-width: 1440px;
  }
`;

export const OptionsList = styled.ul`
  display: flex;
  flex-wrap: wrap;
`;

export const OptionsItem = styled.li`
  position: relative;
  margin-bottom: 15px;
  font-size: 12px;

  @media (min-width: 400px) {
    font-size: 16px;
  }

  &:not(:last-child) {
    margin-right: 3px;
    @media (min-width: 768px) {
      margin-right: 10px;
    }
  }
`;

export const CheckboxList = styled.ul`
  li:not(:last-child) {
    margin-bottom: 25px;
  }
`;
